import { Skeleton } from "../../../components";
import OfferSkeleton from "./OfferSkeleton";

const OffersSkeleton = () => (
  <Skeleton.Group>
    <OfferSkeleton />
  </Skeleton.Group>
);
export default OffersSkeleton;
